export default {
  container: () => import("/opt/buildhome/repo/layouts/container.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)
}